import {
  Container,
  Title,
  Text,
  Card,
  Center,
  Stack,
  ThemeIcon,
} from '@mantine/core';
import { IconClock } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function PendingApproval() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.approved) {
      // If user is already approved, redirect to dashboard
      navigate('/app/dashboard');
    }
  }, [user, navigate]);

  return (
    <Container size="sm" py="xl">
      <Card shadow="sm" padding="xl" radius="md" withBorder>
        <Stack align="center" gap="lg">
          <Center>
            <ThemeIcon size={80} radius="xl" color="yellow" variant="light">
              <IconClock size={48} />
            </ThemeIcon>
          </Center>

          <Title order={2} ta="center">
            {t('pendingApproval.title')}
          </Title>

          <Text size="lg" c="dimmed" ta="center">
            {t('pendingApproval.message')}
          </Text>

          {user?.email && (
            <Text size="sm" c="dimmed" ta="center">
              {t('pendingApproval.email')}: <strong>{user.email}</strong>
            </Text>
          )}

          <Text size="sm" c="dimmed" ta="center">
            {t('pendingApproval.info')}
          </Text>

          <Text
            size="sm"
            c="blue"
            style={{ cursor: 'pointer' }}
            onClick={logout}
          >
            {t('pendingApproval.logout')}
          </Text>
        </Stack>
      </Card>
    </Container>
  );
}
